import {computed, watch} from 'vue'
import {useComponentsStore} from '@/stores/components'
import {useUserStore} from '@/stores/user'
import {useComponentStructureStore} from '@/stores/componentStructure'
import {useFormStore} from '@/stores/form'
import api from '@/services/api'

export function useUniqueValue(props, fieldRef = null) {
    // Pinia Stores
    const componentsStore = useComponentsStore()
    const userStore = useUserStore()
    const componentStructureStore = useComponentStructureStore()
    const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)
    
    // Replicating computed properties
    const tableName = computed(() => formStore.value?.tableName)
    const id = computed(() => formStore.value?.id)
    const franchiseId = computed(() => userStore.user?.franchiseId)
    
    const hasFranchiseIdColumn = computed(() => {
        if (franchiseId.value) {
            const componentId = componentsStore.componentIds[tableName.value]
            const items = componentStructureStore.get(componentId) || []
            const item = items.find(o =>
                (o.modulecomponentsID === componentId || o.modulecomponentsId === componentId)
                && o.columnName === 'franchiseId'
            )
            return item !== undefined
        }
        return false
    })
    
    // Replacing the watch option
    watch(
        () => props.value,
        async (val) => {
            if (props.field.uniqueValuesOnly && props.value) {
                const params = {
                    [props.field.name]: val,
                    id: {ne: id.value}
                }
                
                if (hasFranchiseIdColumn.value) {
                    params.franchiseId = franchiseId.value
                }
                
                try {
                    const o = await api.get('api/component/' + tableName.value, {
                        params
                    })
                    
                    let items = o.data.items || []
                    // Remove archived items
                    items = items.filter(item => item.isArchived !== 1)
                    
                    const msg = items.length ? 'Duplicate value. A unique value is required.' : ''
                    
                    // Maintain legacy behaviour by updating the field object directly
                    props.field.error = msg
                    
                    // Safely handle DOM interaction if ref is passed
                    const el = fieldRef?.value
                    if (el) {
                        el.setCustomValidity(msg)
                        el.checkValidity()
                    }
                } catch (error) {
                    console.error("Unique validation request failed:", error)
                }
            }
        },
        {immediate: true}
    )
}